import Vue from 'vue'
import ElementUI, {
  MessageBox,
  Row,
  Col,
  Button,
  Input,
  Loading,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  CheckboxGroup,
  Divider,
  Popover,
  Collapse,
  CollapseItem,
  Form,
  FormItem,
  Select,
  Option,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Tooltip, Pagination
} from 'element-ui'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import axios from 'axios'
import '@/styles/index.scss' // global css
import Api from './utils/request'

import {findValue} from './utils/pawer'

// 导入全局自定义指令
import { permission, ifPermission, role, btnPermission } from '@/directive/permission'

import '@/icons' // icon
import '@/permission' // permission control
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/icon/iconfont.css'
import Prints from 'vue-print-nb'
import VueClipboard from 'vue-clipboard2'
// import 'default-passive-events'
import 'lib-flexible'
import './utils/flexible'
import './utils/browser_patch'
import './utils/dialog'

import '@/assets/icon/tim.css'
import '@/assets/css/animate.css'

// import '@/css/global.css'


Vue.use(ElementUI, {locale})
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(Prints)
import QRCode from 'qrcodejs2';

Vue.prototype.$qrCode = QRCode
import VueCropper from 'vue-cropper'

Vue.use(VueCropper)
Vue.use(VueQuillEditor)
Vue.prototype.$http = axios
Vue.prototype.$api = Api

Vue.use(VCharts)
import qs from 'qs'      //引入qs
Vue.prototype.$qs = qs

import VueKindEditor from '@/utils/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN.js'


import App from './App'
import router from './router'
import store from './store'

Vue.use(VueKindEditor)

// 注册全局自定义指令
Vue.directive('permission', permission)
Vue.directive('if-permission', ifPermission)
Vue.directive('role', role)
Vue.directive('btn-permission', btnPermission)

Vue.config.productionTip = false
Vue.filter('FormatMoney', function (s) {
  if (s) {
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
    var l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
  } else {
    return '0.00'
  }
})

router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token')
  console.log("to",to)
  if (to.redirectedFrom === '/' && to.path === '/404') {
    return next('/login')
  }
  if (to.path == '/login') {
    return next()
  } else {  
    if (!token) {
      return next('/login')
    } else {
      let hasMenu = ""
      Api.get("/sys/permission/getUserPermissionByToken").then((res) => {

        if(res.data.result.allAuth){
          const permissionsAuth = res.data.result.auth.map(item=>{
            return item.action
          })
        store.commit('SET_PERMISSIONS', permissionsAuth);
  
        }

     

      
        // debugger
        try {
          let path = res.data.result.menu[0].children[0].path.split('/')[2];
          localStorage.setItem('firstPath', path);
        } catch (e) {
          console.log(123, e)
        } finally {
          // debugger
          if ((res.data.code == 200)) {
            let menu = res.data.result.menu;
            hasMenu = findValue(menu, to.path)
            if (!hasMenu) {
              console.log("你没有访问权限")
              if (to.path === '/404') {
                next()
              } else {
                next('/404')
              }
            } else {
              next()
            }
          }
        }
      });
    }
  }
})

//im相关

window.store = store
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。

Vue.prototype.$store = store
Vue.prototype.$confirm = MessageBox.confirm

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(VueClipboard)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Divider)
Vue.use(Popover)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Tooltip)
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})





// WEBPACK FOOTER //
// ./src/main.js